import { displayDateBrazilian } from '../../util/standardizedDate'

export const parseReabSapMrpData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'sap-codigo': item.produtoCodigo,
      'sap-loja': item.centroCodigo,

      'sap-fornecedor': item.estoqueCentroDistribuicaoCodigo,
      'sap-desejada': item.estoqueQuantidadeSugerida,
      'sap-tipo-pedido': 'ZUB',
      'sap-tipo-data': 'T',
      'sap-data-remessa': obterDataRemessa(item.estoqueLeadTime ?? 0),
      'sap-desconto': 0,
      'sap-forma-pagamento': ''
    })
  }

  return res
}

const obterDataRemessa = (day: number) => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + day)
  return formattedDate(tomorrow.toDateString())
}

const formattedDate = (date: string) => {
  return displayDateBrazilian(date)
}
